module.exports = __webpack_public_path__ + "img/pt_Ecran 5.516186b4.png";